import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b028543c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "content-box content-mini-box"
};
const _hoisted_3 = {
  class: "content-left-area content-left-area-mini"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, " 用户类型 ", -1));
const _hoisted_5 = {
  style: {
    "flex": "1",
    "overflow": "auto",
    "margin-top": "2px",
    "position": "relative"
  }
};
const _hoisted_6 = {
  class: "node-label"
};
const _hoisted_7 = {
  class: "content-right-area"
};
const _hoisted_8 = {
  class: "content-right-bar"
};
const _hoisted_9 = {
  key: 0,
  class: "content-right-bar-left"
};
const _hoisted_10 = {
  class: "spanBtn",
  type: "primary",
  style: {
    "padding": "0 5px",
    "background": "#27C83E"
  }
};
const _hoisted_11 = {
  class: "spanBtn",
  type: "primary",
  style: {
    "padding": "0 5px",
    "background": "#FF5F58"
  }
};
const _hoisted_12 = {
  class: "spanBtn",
  type: "primary",
  style: {
    "padding": "0 5px",
    "background": "#FEBD2E"
  }
};
const _hoisted_13 = {
  key: 1,
  class: "content-right-bar-left"
};
const _hoisted_14 = {
  class: "spanBtn",
  type: "primary",
  style: {
    "padding": "0 5px",
    "background": "#27C83E"
  }
};
const _hoisted_15 = {
  class: "spanBtn",
  type: "primary",
  style: {
    "padding": "0 5px",
    "background": "#FF5F58"
  }
};
const _hoisted_16 = {
  class: "spanBtn",
  type: "primary",
  style: {
    "padding": "0 5px",
    "background": "#FEBD2E"
  }
};
const _hoisted_17 = {
  class: "content-right-bar-right"
};
const _hoisted_18 = {
  key: 0,
  class: "user-table-box"
};
const _hoisted_19 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_20 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_21 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_22 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_23 = {
  key: 0,
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_24 = {
  key: 1,
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_25 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_26 = {
  key: 0,
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_27 = {
  key: 1,
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_28 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_29 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_30 = {
  style: {
    "margin-left": "8px"
  }
};
const _hoisted_31 = {
  key: 1,
  class: "user-table-box"
};
const _hoisted_32 = {
  class: "venderTableTitle"
};
const _hoisted_33 = {
  class: "left"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  style: {
    "margin-right": "130px",
    "margin-left": "10px"
  }
};
const _hoisted_36 = {
  style: {
    "margin-right": "21px"
  }
};
const _hoisted_37 = {
  class: "right"
};
const _hoisted_38 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_39 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_40 = {
  style: {
    "margin-left": "8px"
  }
};
const _hoisted_41 = {
  key: 2,
  class: "bottom-pagination-box bottom-pagination-hidden"
};
const _hoisted_42 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_43 = {
  style: {
    "display": "flex",
    "margin-bottom": "20px",
    "flex-direction": "column"
  }
};
const _hoisted_44 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_45 = {
  class: "permission-checks-area"
};
const _hoisted_46 = {
  class: "permission-checks-title permission-checks-title-full"
};
const _hoisted_47 = {
  class: "permission-checks-items"
};
const _hoisted_48 = {
  style: {
    "font-size": "14px",
    "color": "#777"
  }
};
const _hoisted_49 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_50 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_51 = {
  style: {
    "display": "flex",
    "margin-bottom": "20px",
    "flex-direction": "column"
  }
};
const _hoisted_52 = {
  class: "venderEditTitle"
};
const _hoisted_53 = {
  class: "venderEditTitle"
};
const _hoisted_54 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  const _component_a_menu = _resolveComponent("a-menu");
  const _component_a_dropdown = _resolveComponent("a-dropdown");
  const _component_resize_pane = _resolveComponent("resize-pane");
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_a_input_search = _resolveComponent("a-input-search");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined");
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined");
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel");
  const _component_a_collapse = _resolveComponent("a-collapse");
  const _component_vxe_pager = _resolveComponent("vxe-pager");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_modal = _resolveComponent("a-modal");
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_a_checkbox = _resolveComponent("a-checkbox");
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_tree_select = _resolveComponent("a-tree-select");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_resize_pane, {
    onPaneSizeChange: _ctx.contentLeftBarSizeChange,
    class: "content-left-bar"
  }, {
    default: _withCtx(() => [_hoisted_4, _createVNode(_component_a_dropdown, {
      overlayClassName: "custom-dropdown"
    }, {
      overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
        default: _withCtx(() => [_createVNode(_component_a_menu_item, null, {
          default: _withCtx(() => [_ctx.permission.havePermission('用户管理', '新建') ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: _ctx.userControl.addButtonDisable,
            onClick: _ctx.addOrganization,
            class: "sts-button default",
            style: {
              "margin-right": "8px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.create")), 1)]),
            _: 1
          }, 8, ["disabled", "onClick"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_a_menu_item, null, {
          default: _withCtx(() => [_ctx.permission.havePermission('用户管理', '编辑') ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: _ctx.userControl.editButtonDisable,
            onClick: _ctx.editOrganization,
            class: "sts-button default",
            style: {
              "margin-right": "8px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.edit")), 1)]),
            _: 1
          }, 8, ["disabled", "onClick"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_a_menu_item, null, {
          default: _withCtx(() => [_ctx.permission.havePermission('用户管理', '删除') ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: _ctx.userControl.deleteButtonDisable,
            onClick: _ctx.deleteOrganization,
            class: "sts-button default",
            style: {
              "margin-right": "8px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.delete")), 1)]),
            _: 1
          }, 8, ["disabled", "onClick"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_a_menu_item, null, {
          default: _withCtx(() => [_ctx.permission.havePermission('用户管理', '团队权限') ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            onClick: _ctx.updateTeamPermissions,
            class: "sts-button default"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.teamPermissions")), 1)]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_createVNode(_component_a_button, {
        style: {
          "color": "#818181",
          "width": "25px",
          "height": "25px",
          "padding": "0"
        },
        type: "text"
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "setup",
          iconSize: "25px",
          iconColor: '#000000'
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["onPaneSizeChange"]), _createVNode(_component_a_divider, {
    style: {
      "height": "2px",
      "background-color": "#d7d4d4",
      "margin": "22px 0"
    }
  }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tree, {
    style: _normalizeStyle([{
      minWidth: _ctx.leftBarWidth
    }, {
      "position": "absolute"
    }]),
    "default-expand-all": "",
    "expand-on-click-node": false,
    ref: "organizationTree",
    "node-key": "organizationId",
    "default-expanded-keys": _ctx.expandKeys,
    "current-node-key": _ctx.currentKey,
    "highlight-current": "",
    data: _ctx.organizationData,
    props: _ctx.props,
    onCurrentChange: _ctx.currentChange
  }, {
    default: _withCtx(({
      node
    }) => [_createElementVNode("div", _hoisted_6, _toDisplayString(node.label), 1)]),
    _: 1
  }, 8, ["style", "default-expanded-keys", "current-node-key", "data", "props", "onCurrentChange"])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_ctx.currentSelectType !== 3 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("userManage.enable")), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("userManage.disable")), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("userManage.pendingApproval")), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("userManage.openStore")), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("userManage.closeStore")), 1), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("userManage.pendingApproval")), 1)])), _createElementVNode("div", _hoisted_17, [_ctx.currentSelectType == 1 && _ctx.permission.havePermission('用户管理', '新建账号') ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    onClick: _ctx.brandUserCreateClick,
    class: "sts-button default",
    style: {
      "width": "82px",
      "height": "24px",
      "padding": "0",
      "margin-right": "8px"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.createPersonnel")), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_input_search, {
    value: _ctx.searchKeyword,
    "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.searchKeyword = $event),
    placeholder: _ctx.$t('userManage.searchContent'),
    style: {
      "width": "264px"
    },
    onSearch: _ctx.userLoad
  }, null, 8, ["value", "placeholder", "onSearch"])])]), _ctx.currentSelectType != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_vxe_table, {
    stripe: "",
    border: 'none',
    size: "small",
    ref: "userTable",
    loading: _ctx.userLoading,
    "loading-config": {
      icon: 'vxe-icon-indicator roll',
      text: ' '
    },
    height: "auto",
    "row-config": {
      isHover: true
    },
    data: _ctx.userData.data,
    "sort-config": {
      showIcon: false
    },
    "tree-config": {
      reserve: true,
      expandAll: true,
      transform: true,
      rowField: 'id',
      parentField: 'parentId'
    },
    onScroll: _ctx.userTableScroll,
    "row-class-name": _ctx.getRowClassName,
    "header-row-class-name": "tableTitle"
  }, {
    default: _withCtx(() => [_ctx.currentSelectType == 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
      key: 0,
      field: "name",
      width: "300",
      title: _ctx.$t('userManage.fullName')
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(row.name), 1)])]),
      _: 1
    }, 8, ["title"])) : _createCommentVNode("", true), _ctx.currentSelectType == 2 ? (_openBlock(), _createBlock(_component_vxe_column, {
      key: 1,
      field: "name",
      width: "300",
      title: _ctx.$t('userManage.supplierName'),
      "tree-node": ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(row.name), 1), row.primary == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("userManage.mainAccount")), 1)) : _createCommentVNode("", true), row.primary == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("userManage.subAccount")), 1)) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["title"])) : _createCommentVNode("", true), _ctx.currentSelectType == 3 ? (_openBlock(), _createBlock(_component_vxe_column, {
      key: 2,
      field: "name",
      width: "300",
      title: _ctx.$t('userManage.storeName'),
      "tree-node": ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", {
        style: {
          "display": "flex"
        },
        class: _normalizeClass({
          borderLeftOpen: row.stateName === '开店',
          borderLeftClose: row.stateName === '闭店',
          borderLeftAwait: row.stateName === '未审批'
        })
      }, [_createElementVNode("span", _hoisted_25, _toDisplayString(row.name), 1), row.primary == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("userManage.mainAccount")), 1)) : _createCommentVNode("", true), row.primary == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("userManage.subAccount")), 1)) : _createCommentVNode("", true)], 2)]),
      _: 1
    }, 8, ["title"])) : _createCommentVNode("", true), _ctx.currentSelectType == 4 ? (_openBlock(), _createBlock(_component_vxe_column, {
      key: 3,
      field: "name",
      width: "300",
      title: _ctx.$t('userManage.username')
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(row.name), 1)])]),
      _: 1
    }, 8, ["title"])) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
      field: "mobile",
      width: "200",
      title: _ctx.$t('userManage.contact')
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", {
        style: _normalizeStyle({
          'margin-left': row.parentId ? '50px' : ''
        })
      }, _toDisplayString(row.mobile), 5)]),
      _: 1
    }, 8, ["title"]), _createVNode(_component_vxe_column, {
      "min-width": "350",
      field: "email",
      title: _ctx.$t('userManage.email')
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", {
        style: _normalizeStyle({
          'margin-left': row.parentId ? '30px' : ''
        })
      }, _toDisplayString(row.email), 5)]),
      _: 1
    }, 8, ["title"]), _createVNode(_component_vxe_column, {
      "min-width": "200",
      field: "stateName",
      title: _ctx.$t('userManage.status')
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", {
        style: _normalizeStyle({
          'margin-left': row.parentId ? '30px' : ''
        })
      }, _toDisplayString(row.stateName), 5)]),
      _: 1
    }, 8, ["title"]), _createVNode(_component_vxe_column, {
      fixed: "right",
      title: _ctx.$t('userManage.more'),
      width: "200"
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", _hoisted_30, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", null, [_ctx.permission.havePermission('用户管理', '审批通过') || _ctx.permission.havePermission('用户管理', '权限管理') || _ctx.permission.havePermission('用户管理', '新建账号') || _ctx.permission.havePermission('用户管理', '修改账号') || _ctx.permission.havePermission('用户管理', '删除账号') || _ctx.permission.havePermission('用户管理', '移动账号') ? (_openBlock(), _createBlock(_component_a_dropdown, {
        key: 0,
        overlayClassName: "custom-dropdown"
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [row.stateId == 3 && _ctx.permission.havePermission('用户管理', '审批账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              onClick: $event => _ctx.UserApproveClick(row),
              style: {
                "width": "100px"
              },
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.approved")), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), _ctx.permission.havePermission('用户管理', '权限管理') ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              onClick: $event => _ctx.UserPermissionsClick(row),
              style: {
                "width": "100px"
              },
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.permissionManagement")), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), (row.type == 2 || row.type == 3) && row.primary === null && _ctx.permission.havePermission('用户管理', '新建账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              onClick: $event => _ctx.UserCreateClick(row),
              style: {
                "width": "100px"
              },
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.createAccount")), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), (row.type == 1 || (row.type == 2 || row.type == 3) && row.primary !== null) && _ctx.permission.havePermission('用户管理', '修改账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              onClick: $event => _ctx.UserUpdateClick(row),
              style: {
                "width": "100px"
              },
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.modifyAccount")), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), (row.type == 1 || (row.type == 2 || row.type == 3) && row.primary == 2) && _ctx.permission.havePermission('用户管理', '删除账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              onClick: $event => _ctx.UserDeleteClick(row),
              style: {
                "width": "100px"
              },
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.deleteAccount")), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), row.type == 1 && _ctx.permission.havePermission('用户管理', '移动账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              onClick: $event => _ctx.UserMoveClick(row),
              style: {
                "width": "100px"
              },
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.moveAccount")), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]),
        default: _withCtx(() => [_createVNode(_component_a_button, {
          style: {
            "color": "#818181",
            "border": "1px solid #818181",
            "width": "25px",
            "height": "25px",
            "border-radius": "50%",
            "padding": "0"
          },
          type: "text"
        }, {
          default: _withCtx(() => [_createTextVNode(" ··· ")]),
          _: 1
        })]),
        _: 2
      }, 1024)) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["loading", "data", "onScroll", "row-class-name"])])) : (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_a_collapse, {
    activeKey: _ctx.activeKey,
    "onUpdate:activeKey": _cache[1] || (_cache[1] = $event => _ctx.activeKey = $event),
    ghost: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendorUserData.data, (x, index) => {
      return _openBlock(), _createBlock(_component_a_collapse_panel, {
        key: String(index),
        showArrow: false,
        collapsible: 'icon'
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", {
          onClick: _withModifiers($event => _ctx.toggleCollapse(index), ["stop"]),
          style: {
            "cursor": "pointer",
            "width": "40px",
            "text-align": "center"
          }
        }, [_ctx.activeKey.includes(String(index)) ? (_openBlock(), _createBlock(_component_CaretDownOutlined, {
          key: 0
        })) : (_openBlock(), _createBlock(_component_CaretRightOutlined, {
          key: 1
        }))], 8, _hoisted_34), _createElementVNode("span", _hoisted_35, _toDisplayString(x.vendorName), 1), _createElementVNode("span", null, [_createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('userManage.subAccountCount')), 1), _createTextVNode(_toDisplayString(x.users.length), 1)])]), _createElementVNode("div", _hoisted_37, [_ctx.permission.havePermission('用户管理', '审批通过') || _ctx.permission.havePermission('用户管理', '权限管理') || _ctx.permission.havePermission('用户管理', '新建账号') || _ctx.permission.havePermission('用户管理', '修改账号') || _ctx.permission.havePermission('用户管理', '删除账号') || _ctx.permission.havePermission('用户管理', '移动账号') ? (_openBlock(), _createBlock(_component_a_dropdown, {
          key: 0,
          overlayClassName: "custom-dropdown"
        }, {
          overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
            default: _withCtx(() => [_createVNode(_component_a_menu_item, null, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                onClick: $event => _ctx.editVenderInfo(x),
                style: {
                  "width": "100px"
                },
                class: "sts-button default"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('userManage.editInfo')), 1)]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_a_button, {
            style: {
              "color": "#818181",
              "border": "1px solid #818181",
              "width": "25px",
              "height": "25px",
              "border-radius": "50%",
              "padding": "0"
            },
            type: "text"
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              iconName: "setupwhite",
              iconSize: "25px",
              iconColor: '#FFFFFF'
            })]),
            _: 1
          })]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_vxe_table, {
          stripe: "",
          border: 'none',
          size: "small",
          ref_for: true,
          ref: "userTable111111",
          loading: _ctx.userLoading,
          "loading-config": {
            icon: 'vxe-icon-indicator roll',
            text: ' '
          },
          "row-config": {
            isHover: true
          },
          data: _ctx.userData.data.filter(item => item.parentId === x.vendorId),
          "sort-config": {
            showIcon: false
          },
          "row-class-name": _ctx.getRowClassName
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "name",
            width: "200",
            title: _ctx.$t('userManage.username')
          }, {
            header: _withCtx(({
              column
            }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(row.name), 1)])]),
            _: 1
          }, 8, ["title"]), _createVNode(_component_vxe_column, {
            field: "primaryAccount",
            width: "200",
            title: _ctx.$t('userManage.accountType')
          }, {
            header: _withCtx(({
              column
            }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.primary == '1' ? _ctx.$t('userManage.mainAccount') : _ctx.$t('userManage.subAccount')), 1)]),
            _: 1
          }, 8, ["title"]), _createVNode(_component_vxe_column, {
            field: "mobile",
            width: "200",
            title: _ctx.$t('userManage.contact')
          }, {
            header: _withCtx(({
              column
            }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.mobile), 1)]),
            _: 1
          }, 8, ["title"]), _createVNode(_component_vxe_column, {
            "min-width": "350",
            field: "email",
            title: _ctx.$t('userManage.email')
          }, {
            header: _withCtx(({
              column
            }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.email), 1)]),
            _: 1
          }, 8, ["title"]), _createVNode(_component_vxe_column, {
            "min-width": "200",
            field: "stateName",
            title: _ctx.$t('userManage.status')
          }, {
            header: _withCtx(({
              column
            }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.stateName), 1)]),
            _: 1
          }, 8, ["title"]), _createVNode(_component_vxe_column, {
            fixed: "right",
            title: _ctx.$t('userManage.more'),
            width: "100"
          }, {
            header: _withCtx(({
              column
            }) => [_createElementVNode("span", _hoisted_40, _toDisplayString(column.title), 1)]),
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", null, [_ctx.permission.havePermission('用户管理', '审批通过') || _ctx.permission.havePermission('用户管理', '权限管理') || _ctx.permission.havePermission('用户管理', '新建账号') || _ctx.permission.havePermission('用户管理', '修改账号') || _ctx.permission.havePermission('用户管理', '删除账号') || _ctx.permission.havePermission('用户管理', '移动账号') ? (_openBlock(), _createBlock(_component_a_dropdown, {
              key: 0,
              overlayClassName: "custom-dropdown"
            }, {
              overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
                default: _withCtx(() => [row.stateId == 3 && _ctx.permission.havePermission('用户管理', '审批账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: 0
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    onClick: $event => _ctx.UserApproveClick(row),
                    style: {
                      "width": "100px"
                    },
                    class: "sts-button default"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.approved")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), _ctx.permission.havePermission('用户管理', '权限管理') ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: 1
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    onClick: $event => _ctx.UserPermissionsClick(row),
                    style: {
                      "width": "100px"
                    },
                    class: "sts-button default"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.permissionManagement")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), (row.type == 2 || row.type == 3) && row.primary === null && _ctx.permission.havePermission('用户管理', '新建账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: 2
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    onClick: $event => _ctx.UserCreateClick(row),
                    style: {
                      "width": "100px"
                    },
                    class: "sts-button default"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.createAccount")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), (row.type == 1 || (row.type == 2 || row.type == 3) && row.primary !== null) && _ctx.permission.havePermission('用户管理', '修改账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: 3
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    onClick: $event => _ctx.UserUpdateClick(row),
                    style: {
                      "width": "100px"
                    },
                    class: "sts-button default"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.modifyAccount")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), (row.type == 1 || (row.type == 2 || row.type == 3) && row.primary == 2) && _ctx.permission.havePermission('用户管理', '删除账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: 4
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    onClick: $event => _ctx.UserDeleteClick(row),
                    style: {
                      "width": "100px"
                    },
                    class: "sts-button default"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.deleteAccount")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), row.type == 1 && _ctx.permission.havePermission('用户管理', '移动账号') ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: 5
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    onClick: $event => _ctx.UserMoveClick(row),
                    style: {
                      "width": "100px"
                    },
                    class: "sts-button default"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userManage.moveAccount")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true)]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => [_createVNode(_component_a_button, {
                style: {
                  "color": "#818181",
                  "border": "1px solid #818181",
                  "width": "25px",
                  "height": "25px",
                  "border-radius": "50%",
                  "padding": "0"
                },
                type: "text"
              }, {
                default: _withCtx(() => [_createTextVNode(" ··· ")]),
                _: 1
              })]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["title"])]),
          _: 2
        }, 1032, ["loading", "data", "row-class-name"])])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["activeKey"])])), _ctx.currentSelectType != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_vxe_pager, {
    class: "sts-pager",
    background: "",
    "page-size": _ctx.paginationData.pageSize,
    "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => _ctx.paginationData.pageSize = $event),
    "current-page": _ctx.paginationData.currentPage,
    "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => _ctx.paginationData.currentPage = $event),
    "pager-count": 5,
    total: _ctx.paginationData.totalSize,
    "page-sizes": _ctx.paginationData.pageSizes,
    layouts: ['Total'],
    onPageChange: _ctx.paginationCurrentChange
  }, null, 8, ["page-size", "current-page", "total", "page-sizes", "onPageChange"])])) : _createCommentVNode("", true)])])]), _createVNode(_component_a_modal, {
    open: _ctx.organizationDialogVisible,
    "onUpdate:open": _cache[5] || (_cache[5] = $event => _ctx.organizationDialogVisible = $event),
    closable: false,
    width: "466px",
    zIndex: 1001,
    centered: true,
    ref: "organizationDialog"
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.operateStatus.organizationDialogTitle), 1)]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _ctx.cancelSaveOrganization
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.cancel")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.confirmSaveOrganization
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_a_form, {
      ref: "organizationForm",
      inline: true,
      rules: _ctx.organizationFormRules,
      model: _ctx.organizationFormData,
      "show-message": false,
      "label-col": {
        span: 4
      },
      labelAlign: 'left'
    }, {
      default: _withCtx(() => [_createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "organizationName",
        label: _ctx.$t('userManage.name')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          ref: "organizationNameInput",
          value: _ctx.organizationFormData.organizationName,
          "onUpdate:value": _cache[4] || (_cache[4] = $event => _ctx.organizationFormData.organizationName = $event),
          placeholder: _ctx.$t('userManage.enterName')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }, 8, ["label"])]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.userDialogVisible,
    "onUpdate:open": _cache[11] || (_cache[11] = $event => _ctx.userDialogVisible = $event),
    closable: false,
    width: "466px",
    zIndex: 1001,
    centered: true,
    ref: "userDialog"
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.operateStatus.userDialogTitle), 1)]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _ctx.cancelSaveUser
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.cancel")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.confirmSaveUser
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_a_form, {
      ref: "userForm",
      inline: true,
      rules: _ctx.userFormRules,
      model: _ctx.userFormData,
      "show-message": false,
      "label-width": "0px",
      "label-col": {
        span: 5
      },
      labelAlign: 'left'
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "lastName",
        label: _ctx.$t('userManage.lastName')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          ref: "lastNameInput",
          value: _ctx.userFormData.lastName,
          "onUpdate:value": _cache[6] || (_cache[6] = $event => _ctx.userFormData.lastName = $event),
          placeholder: _ctx.$t('userManage.enterLastName')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "firstName",
        label: _ctx.$t('userManage.firstName')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.userFormData.firstName,
          "onUpdate:value": _cache[7] || (_cache[7] = $event => _ctx.userFormData.firstName = $event),
          placeholder: _ctx.$t('userManage.enterFirstName')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "mobile",
        label: _ctx.$t('userManage.phoneNumber')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.userFormData.mobile,
          "onUpdate:value": _cache[8] || (_cache[8] = $event => _ctx.userFormData.mobile = $event),
          placeholder: _ctx.$t('userManage.enterContact')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "email",
        label: _ctx.$t('userManage.email')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.userFormData.email,
          "onUpdate:value": _cache[9] || (_cache[9] = $event => _ctx.userFormData.email = $event),
          placeholder: _ctx.$t('userManage.enterEmail')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "remark",
        label: _ctx.$t('userManage.accountDescription')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_textarea, {
          value: _ctx.userFormData.remark,
          "onUpdate:value": _cache[10] || (_cache[10] = $event => _ctx.userFormData.remark = $event),
          autoSize: {
            minRows: 2,
            maxRows: 4
          }
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["label"])])]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.permissionDialogVisible,
    "onUpdate:open": _cache[13] || (_cache[13] = $event => _ctx.permissionDialogVisible = $event),
    closable: false,
    width: "850px",
    zIndex: 1001,
    centered: true,
    ref: "userDialog"
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.operateStatus.permissionDialogTitle), 1)]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _cache[12] || (_cache[12] = $event => _ctx.permissionDialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.cancel")), 1)]),
      _: 1
    }), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.confirmPermissionUser
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleEditData.data, (module, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "permission-checks-box permission-checks-box-column"
      }, [_createElementVNode("div", _hoisted_46, _toDisplayString(module.moduleName) + "： ", 1), _createElementVNode("div", _hoisted_47, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.modulePermissions, (modulePermission, index) => {
        return _openBlock(), _createBlock(_component_a_checkbox, {
          key: index,
          checked: modulePermission.checked,
          "onUpdate:checked": $event => modulePermission.checked = $event,
          style: {
            "margin-right": "40px",
            "margin-bottom": "20px",
            "width": "120px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_48, _toDisplayString(modulePermission.modulePermissionName), 1)]),
          _: 2
        }, 1032, ["checked", "onUpdate:checked"]);
      }), 128))])]);
    }), 128))])]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.moveUserOrganizationDialogVisible,
    "onUpdate:open": _cache[15] || (_cache[15] = $event => _ctx.moveUserOrganizationDialogVisible = $event),
    closable: false,
    width: "466px",
    zIndex: 1001,
    centered: true,
    ref: "organizationDialog"
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('userManage.moveAccount')), 1)]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _ctx.cancelUserMove
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.cancel")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.confirmUserMove
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_a_form, {
      ref: "moveUserOrganizationForm",
      inline: true,
      rules: _ctx.moveUserOrganizationFormRules,
      model: _ctx.moveUserOrganizationFormData,
      "show-message": false,
      "label-col": {
        span: 4
      },
      labelAlign: 'left'
    }, {
      default: _withCtx(() => [_createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "organizationId",
        label: "组织加构"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tree_select, {
          value: _ctx.moveUserOrganizationFormData.organizationId,
          "onUpdate:value": _cache[14] || (_cache[14] = $event => _ctx.moveUserOrganizationFormData.organizationId = $event),
          treeData: _ctx.organizationTreeData,
          treeDefaultExpandAll: true,
          fieldNames: {
            label: 'organizationName',
            value: 'organizationId',
            children: 'children'
          },
          showSearch: "",
          placeholder: "组织架构",
          class: "cust-select"
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
            class: "ant-select-suffix"
          })]),
          _: 1
        }, 8, ["value", "treeData"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.venderDialogVisible,
    "onUpdate:open": _cache[22] || (_cache[22] = $event => _ctx.venderDialogVisible = $event),
    closable: false,
    width: "466px",
    zIndex: 1001,
    centered: true,
    ref: "userDialog"
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('userManage.editInfo')), 1)]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _ctx.venderFormDataCancel
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.cancel")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.venderFormDataFinish
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_a_form, {
      ref: "editVenderForm",
      inline: true,
      rules: _ctx.venderFormRules,
      model: _ctx.venderFormData,
      "show-message": false,
      "label-width": "0px",
      "label-col": {
        span: 5
      },
      labelAlign: 'left'
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('userManage.companyInfo')), 1), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "vendorFullName",
        label: _ctx.$t('userManage.chineseFullName')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          ref: "fullNameInput",
          value: _ctx.venderFormData.vendorFullName,
          "onUpdate:value": _cache[16] || (_cache[16] = $event => _ctx.venderFormData.vendorFullName = $event)
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_row, {
        gutter: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_a_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            name: "vendorName",
            label: _ctx.$t('userManage.chineseShortName'),
            "label-col": {
              span: 10
            },
            "wrapper-col": {
              span: 14
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: _ctx.venderFormData.vendorName,
              "onUpdate:value": _cache[17] || (_cache[17] = $event => _ctx.venderFormData.vendorName = $event)
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }), _createVNode(_component_a_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            name: "vendorNameEn",
            label: _ctx.$t('userManage.enShortName'),
            "label-col": {
              span: 10
            },
            "wrapper-col": {
              span: 14
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: _ctx.venderFormData.vendorNameEn,
              "onUpdate:value": _cache[18] || (_cache[18] = $event => _ctx.venderFormData.vendorNameEn = $event)
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('userManage.mainAccountInfo')), 1), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "contactName",
        label: _ctx.$t('userManage.username')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.venderFormData.contactName,
          "onUpdate:value": _cache[19] || (_cache[19] = $event => _ctx.venderFormData.contactName = $event)
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "contactMobile",
        label: _ctx.$t('userManage.contact')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.venderFormData.contactMobile,
          "onUpdate:value": _cache[20] || (_cache[20] = $event => _ctx.venderFormData.contactMobile = $event)
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_a_form_item, {
        style: {
          "width": "100%",
          "margin-right": "0px"
        },
        name: "contactEmail",
        label: _ctx.$t('userManage.email')
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.venderFormData.contactEmail,
          "onUpdate:value": _cache[21] || (_cache[21] = $event => _ctx.venderFormData.contactEmail = $event)
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["label"])])]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["open"])], 64);
}